import React, { useContext, useEffect, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek'
import { ListAutorizarRequisasMantenimiento, ListAutorizarRequisasMantenimientoMASS, ListAutorizarRequisasMantenimientoMateriales, ListAutorizarRequisasMantenimientoUniformes, ListRequisasMantenimiento, SPPermisosRequisasDeMateriales, cancelarRequisasMantenimiento } from '../../../API/Mantenimiento/Requisas/RequisasMantenimientoRequests';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { Button, Checkbox, InputText, Tag, Toast } from 'primereact';
import { color1, color2, color3, color4, color5, color6, colorCotton, colorSintetico } from '../../../Styles/Colors';
import DialogPassword from '../../../Base/Components/Dialog/DialogPassword/DialogPassword';
import { toastShow } from '../../../Base/Services/ToastService';
import { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { getDateProduction } from '../../../Base/Services/FechasService';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';

function AutorizarRequisasMantenimientoScreen() {

  const { userAuth } = useContext(AuthContext);

  const toast = useRef(null);

  const navigate = useNavigate();

  const [requisas, setRequisas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [display, setDisplay] = useState(false);
  const [selected, setSelected] = useState([]);
  const [permisoChange, setPermisoChange] = useState(null);
  const [password, setPassword] = useState('');
  const [showDialogCancelar, setShowDialogCancelar] = useState(false);
  const [comentarioCancelar, setComentarioCancelar] = useState('');
  const [dates, setDates] = useState([new Date(), new Date()]);


  const getInfo = async () => {
    setLoading(true);
    setSelected([]);
    if(window.location.href.includes('Uniformes')){
      const t = await ListAutorizarRequisasMantenimientoUniformes();
      setRequisas(t);
    }else{
      if (window.location.href.includes('MASS')) {
        const t = await ListAutorizarRequisasMantenimientoMASS();
        setRequisas(t);
      } else {
        if (window.location.href.includes('Materiales')) {
          const t = await ListAutorizarRequisasMantenimientoMateriales();
          setRequisas(t);
        } else {
          if (window.location.href.includes('Listado')) {
            const d = getDateProduction(dates);
            const t = await ListRequisasMantenimiento({fecha1: d[0], fecha2: d[1]});
            console.log(t);
            setRequisas(t);
          } else {
            const t = await ListAutorizarRequisasMantenimiento();
            setRequisas(t);
          }
        }
      }
    }
    setLoading(false);
  }

  const cancelarRequisas = async () => {
    setLoading(true);
    if (selected.length > 0) {
      const d = selected.map(e => e.IdDetalle);
      const a = {
        IdRequisaDetalle: d.toString(),
        ComentarioCancelacion: comentarioCancelar
      }
      const t = await cancelarRequisasMantenimiento(a);
      getInfo();
      onHideCancelar();
      toastShow(toast, 'success', 'Requisas canceladas');

    } else {
      toastShow(toast, 'warn', 'Seleccione las requisas a cancelar');
    }
    setLoading(false);
  }

  const estadoTemplate = (rowData) => {
    switch (rowData.StatusName) {
      case 'Pendiente Autorizar':
        return <Tag className='col-12' value={rowData.StatusName} style={{ background: color5 }} />

      case 'Pendiente':
        return <Tag severity='success' className='col-12' value={rowData.StatusName} />
      case 'En Firma':
        return <Tag severity='info' className='col-12' value={rowData.StatusName} />

      case 'Despachado':
        return <Tag severity='info' className='col-12' value={rowData.StatusName}  style={{ background: '#CCCC' }}/>

      case 'Pendiente Despacho':
        return <Tag severity='info' className='col-12' value={rowData.StatusName}  style={{ background: color4 }}/>
      case 'Pendiente MASS':
        return <Tag severity='info' className='col-12' value={rowData.StatusName}  style={{ background: color6 }}/>

      default:
        break;
    }
    return <div>{rowData.StatusName}</div>
  }

  const onChangePermiso = (rowData, permiso) => {
    if (selected.length === 0) {
      setSelected([rowData]);
    }
    setPermisoChange(permiso)
    setDisplay(true);
  }

  const autorizarPermisoTemplate = (rowData, permiso) => {
    let a
    switch (permiso) {
      case 1:
        a = <Checkbox checked={rowData.Permiso1} onChange={(e) => onChangePermiso(rowData, permiso)} />
        break;
      case 2:
        a = <Checkbox checked={rowData.Permiso2} onChange={(e) => onChangePermiso(rowData, permiso)} />
        break;
      case 3:
        a = <Checkbox checked={rowData.Permiso3} onChange={(e) => onChangePermiso(rowData, permiso)} />
        break;
      case 4:
        a = <Checkbox checked={rowData.Permiso3} onChange={(e) => onChangePermiso(rowData, permiso)} />
        break;

      default:
        a = <Checkbox />
        break;
    }

    return a;

  }

  const onHide = () => {
    setDisplay(false);
    setSelected([]);
    setPermisoChange(null);
    setPassword('');
  }

  const onHideCancelar = () => {
    setShowDialogCancelar(false);
    setComentarioCancelar('');
  }

  const authPermiso = async (password) => {


    if ((password || window.location.href.includes('Uniformes') || window.location.href.includes('Materiales')) && permisoChange) {


      const detalles = selected.map((e, i) => {
        let valor = false;
        switch (permisoChange) {
          case 1:
            valor = !e?.Permiso1
            break;
          case 2:
            valor = !e?.Permiso2
            break;
          case 3:
            valor = !e?.Permiso3
            break;
          case 4:
            valor = !e?.Permiso3
            break;
          default:
            break;
        }
        return {
          IdRequisaDetalle: e.IdDetalle,
          NoPermiso: permisoChange,
          Permiso: valor
        }
      })

      const t = await SPPermisosRequisasDeMateriales(detalles, password);

      const error = [];
      t?.detalles?.forEach(e => {
        if (e[0].ESTADO < 0) {
          if (!error.includes(e[0].MENSAJE)) {
            error.push(e[0].MENSAJE)
          }
        }
      });

      if (error.length > 0) {
        error.forEach(e => {
          setTimeout(() => {
            toastShow(toast, 'warn', e)
          }, 600);
        })
        onHide();
      } else {
        getInfo();
        toastShow(toast, 'success', 'Permisos actualizados.');
        onHide();
      }
    }


    onHide()
  }

  const authByUserOrRol = async () => {
    // const user = JSON.parse(localStorage.getItem('ppfUser'));
    if (userAuth.IdRol === 1) {
      authPermiso('ppfbv/?');
    } else {
      toastShow(toast, 'warn', 'Credenciales incorrectas.')
      onHide()
    }
  }

  const columns = [
    {
      header: 'Requisa',
      field: 'Requisa',
      className: 'Xsmall',
      frozen: true
    },
    {
      header: 'Estado',
      field: 'StatusName',
      className: 'small',
      frozen: true,
      Format: 'Template',
      body: estadoTemplate
    },
    {
      header: 'Codigo Producto',
      field: 'CodigoProducto',
      className: 'Xsmall',
      frozen: true
    },
    {
      header: 'Fecha',
      field: 'FechaF',
      Format: 'DateTime',
    },
    {
      header: 'Producto',
      field: 'NombreProducto',
      className: 'Xlarge',
      frozen: true,
      Sumary: 'count'
    },
    {
      header: 'Descripcion',
      field: 'Descripcion',
      className: 'Xlarge'
    },
    {
      header: 'Unidad',
      field: 'UnitName',
      className: 'Xsmall'
    },

    {
      header: 'Solicitado',
      field: 'Qty',
      Format: 'Decimal',
      className: 'small',
      Sumary: 'sum'
    },
    {
      header: 'Inventario',
      field: 'Inventario',
      className: 'small',
      Format: 'Decimal',
      Sumary: 'sum'
    },
    {
      header: 'Area',
      field: 'Area',
    },
    {
      header: 'Solicita',
      field: 'Solicita',
    },
    {
      header: 'Tecnico',
      field: 'TecnicoConcat',
    },
    {
      header: 'Tecnico D',
      field: 'NombreConcatTecD',
    },
    // {
    //   header: 'AreaGeneral',
    //   field: 'AreaGeneral',
    // },
    {
      header: 'Firma solicita',
      field: 'UsuarioPermiso1',
      className: 'small'
    },
    {
      header: 'Fecha firma solicita',
      field: 'FechaPermiso1',
      Format: 'DateTime'
    },
    {
      header: 'Recibe',
      field: 'UsuarioPermiso2',
      className: 'small',
    },
    {
      header: 'Fecha Recibe',
      field: 'FechaPermiso2',
      Format: 'DateTime'
    },
    {
      header: 'Permiso 3',
      field: 'UsuarioPermiso3',
      className: 'small',
    },
    {
      header: 'Fecha permiso 3',
      field: 'FechaPermiso3',
      Format: 'DateTime'
    },
    {
      header: 'Precio L',
      field: 'PrecioL',
      className: 'small',
      Format: 'Decimal',
      Sumary: 'sum'
    },
    {
      header: 'Precio $',
      field: 'PrecioD',
      className: 'small',
      Format: 'Decimal',
      Sumary: 'sum'
    },
    {
      header: 'Total L',
      field: 'TotalL',
      className: 'small',
      Format: 'Decimal',
      Sumary: 'sum',
      frozen: true,
      alignFrozen: 'right',
    },
    {
      header: 'Total $',
      field: 'TotalD',
      className: 'small',
      Format: 'Decimal',
      Sumary: 'sum',
      frozen: true,
      alignFrozen: 'right',
    },



    {
      header: 'Solicita',
      field: '',
      Format: 'Template',
      body: (e) => autorizarPermisoTemplate(e, 1),
      className: 'Xsmall',
      frozen: true,
      alignFrozen: 'right',
      disabled: false,
      hidden:  !window.location.href.includes('MASS') && !window.location.href.includes('Materiales') && !window.location.href.includes('Listado') 
    },
    {
      header: 'Recibe',
      field: '',
      Format: 'Template',
      body: (e) => autorizarPermisoTemplate(e, 2),
      className: 'Xsmall',
      frozen: true,
      alignFrozen: 'right',
      disabled: false,
      hidden: window.location.href.includes('Materiales')
    },
    {
      header: 'MASS',
      field: '',
      Format: 'Template',
      body: (e) => autorizarPermisoTemplate(e, 3),
      className: 'Xsmall',
      frozen: true,
      alignFrozen: 'right',
      disabled: false,
      hidden: window.location.href.includes('MASS')
    },
    {
      header: 'RRHH',
      field: '',
      Format: 'Template',
      body: (e) => autorizarPermisoTemplate(e, 4),
      className: 'Xsmall',
      frozen: true,
      alignFrozen: 'right',
      disabled: false,
      hidden: window.location.href.includes('Uniformes')
    },

  ]


  const table = {
    Data: requisas,
    Columns: columns,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
  }

  useEffect(() => {
    setTitlePage(window.location.href.includes('Materiales') ? 'Aprobar Materiales Mantenimiento' : (window.location.href.includes('Listado') ? 'Listado requisa' :'Autorizar requisa' ));
    getInfo();
  }, [navigate])

  return (
    <div>
      <Toast ref={toast} />
      <DialogPassword
        display={display}
        selected={selected}
        loading={loading}
        authByUserOrRol={authByUserOrRol}
        authPermiso={authPermiso}
        onHide={onHide}
        password={password}
        setPassword={setPassword}
        showInput={!window.location.href.includes('Materiales') && !window.location.href.includes('Uniformes')}
      />
      <Card
        titulo={<div className='d-flex' style={{ gap: 10 }}>

          {window.location.href.includes('Materiales') ? <h3>Aprobar Materiales Mantenimiento</h3> : (window.location.href.includes('Listado') ? <h3>Listado requisa</h3> :<h3>Autorizar requisa</h3> ) }

          {window.location.href.includes('Listado') ? <CalendarWeek
            date={dates}
            setDate={(setDates)}
            selectionMode='range'
            loading={loading}
            buscar={getInfo}
          />
            :
            <Button
              icon="pi pi-sync"
              type="button"
              className="listado__botones ms-2"
              loading={loading}
              tooltip="Buscar"
              tooltipOptions={{ className: 'purple-tooltip', position: 'top' }}
              onClick={e => getInfo()} >
            </Button>
          }


          <Button
            icon="pi pi-trash"
            type="button"
            className="listado__botones"
            loading={loading}
            tooltip="Cancelar"
            tooltipOptions={{ className: 'purple-tooltip', position: 'top' }}
            onClick={e => {
              if (selected.length > 0) {
                setShowDialogCancelar(true)
              } else {
                toastShow(toast, 'warn', 'Seleccione las requisas a cancelar');
              }
            }} >
          </Button>
        </div>}
        contenido={<div style={{ height: '90vh' }} className='p-3'>
          <div className="p-1 d-flex">
            {/* <CalendarWeek date={date} setDate={setDate} selectionMode='range' buscar={getInfo} loading={loading} /> */}
          </div>
          <div className="p-1" style={{ height: '88vh' }}>
            <AgGrid table={table} />
          </div>
        </div>}
      />
      <Dialog visible={showDialogCancelar} onHide={onHideCancelar}
        header={<h3>Cancelar requisas</h3>}
        footer={<div className='d-flex' style={{ gap: 10, justifyContent: 'flex-end' }}>
          <Button label='Salir' onClick={onHideCancelar} />
          <Button label='Guardar' onClick={cancelarRequisas} />
        </div>}
      >
        <div className='p-4'>
          <h5>{selected.length} items a cancelar</h5>
          <InputText
            value={comentarioCancelar}
            onChange={e => setComentarioCancelar(e.target.value)}
            style={{ minWidth: 400 }}
            className='mt-4'
            placeholder='Comentario'
          />
        </div>
      </Dialog>
    </div>
  )
}

export default AutorizarRequisasMantenimientoScreen